import { combineReducers } from 'redux'

import { HIDE_TODAY_WARNING, SHOW_TODAY_WARNING } from './constants'

function todayWarning(state = false, action) {
  switch (action.type) {
    case SHOW_TODAY_WARNING:
      return true
    case HIDE_TODAY_WARNING:
      return false
    default:
      return state
  }
}

export default combineReducers({
  todayWarning,
})
